<template>
  <div class="monitoring">
    <div style="width: 100%; height: 100%;padding: 0px 20px 40px 20px;box-sizing: border-box">
      <div class="real_time_monitoring information_box light_border">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <!--视频监控区域-->
        <div class="video_win">
          <div class="video_box" style="position: relative;top: 0px;width: 100%;display: flex;justify-content: center;" id="videoBox">
          </div>
          <div style="width: 100%;height: 24%; display: flex;justify-content: space-between" >
            <div class="m_video_box" id="videoBox2">

            </div>

            <div class="m_video_box" id="videoBox3">

            </div>

            <div class="m_video_box" id="videoBox4">

            </div>

          </div>
          <div style="width: 100%;height: 50px; display: flex;justify-content: space-between" >
            <div class="n_video_box">
              <div style="text-align: center;line-height: 50px;">
                <button style="color:white;border:0px;background-color:transparent;" @click="playerFirst2()">{{video_name2}}</button>
              </div>
            </div>
            <div class="n_video_box">
              <div style="text-align: center;line-height: 50px;">
                <button style="color:white;border:0px;background-color:transparent;" @click="playerFirst3()">{{video_name3}}</button>
              </div>
            </div>
            <div class="n_video_box">
              <div style="text-align: center;line-height: 50px;">
                <button style="color:white;border:0px;background-color:transparent;" @click="playerFirst4()">{{video_name4}}</button>
              </div>
            </div>
          </div>
          <div class="video_win_btn">
          </div>

        </div>
        <!--视频操作区域-->
        <div class="operation_win" style="position: relative;top: 50px;">
          <div class="income_btn focus" style="color: #FFFFFF">云台控制</div>
          <div class="control_btn">
            <div class="direction_btn">
              <button style="background: url('/static/img/btn/1.png') no-repeat center center;" @click="left_top()" class="dark"></button>
              <button style="background: url('/static/img/btn/2.png') no-repeat center center" @click="top()" class="dark"></button>
              <button style="background: url('/static/img/btn/3.png') no-repeat center center" @click="right_top()" class="dark"></button>
              <button style="background: url('/static/img/btn/4.png') no-repeat center center" @click="left_center()" class="dark"></button>
              <button style="background: url('/static/img/btn/5.png') no-repeat center center" @click="center_center()" class="dark"></button>
              <button style="background: url('/static/img/btn/6.png') no-repeat center center" @click="right_center()" class="dark"></button>
              <button style="background: url('/static/img/btn/7.png') no-repeat center center" @click="left_bottom()" class="dark"></button>
              <button style="background: url('/static/img/btn/8.png') no-repeat center center" @click="center_bottom()" class="dark"></button>
              <button style="background: url('/static/img/btn/9.png') no-repeat center center" @click="right_bottom" class="dark"></button>
            </div>
            <div class="direction_btn">
              <button style="background: url('/static/img/btn/+.png') no-repeat center center" @click="magnify()" class="dark">+</button>
              <button>倍数</button>
              <button style="background: url('/static/img/btn/-.png') no-repeat center 18px" @click="shrink()" class="dark">-</button>
              <button style="background: url('/static/img/btn/+.png') no-repeat center center" @click="focus_add()" class="dark">+</button>
              <button>变焦</button>
              <button style="background: url('/static/img/btn/-.png') no-repeat center 18px" @click="focus_reduce()" class="dark">-</button>
            </div>
          </div>
          <div class="income_btn focus" style="color: #FFFFFF;padding: 10px 0px;">监控点</div>
          <div class="monitory_point">
            <div  class="monitory_point_box">
              <span style="width: 100px;">{{search[0].title}}</span>
              <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
                <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </div>
            <div  class="monitory_point_box">
              <span style="width: 100px;">{{search[1].title}}</span>
              <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
                <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </div>
            <div  class="monitory_point_box">
              <span style="width: 100px;">{{search[2].title}}</span>
              <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
                <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </div>
            <div class="monitory_point_box" style="width: 110px;">
              <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getVideoList()"><span class="el-icon-search"></span>搜索</button>
            </div>
            <!--<div class="monitory_point_box" style="width: 110px;">-->
              <!--<button :class='["search_btn","blue","icon_btn","clearborder"]' @click="goHistoryVideo()">历史回放</button>-->
            <!--</div>-->
          </div>
          <div class="table_content">
            <table>
              <thead>
              <tr>
                <th>设备识别码</th>
                <th>灯杆编号</th>
                <th>位置</th>
                <th width="100px">设备状态</th>
              </tr>
              </thead>
              <tbody style="height: 312px">
              <tr v-for="(item,index) in resourcePageData" @click="open(item.device_serial,item.url)">
                <td>{{item.device_serial}}</td>
                <td>{{item.lampost_id}}</td>
                <td>{{item.site}}</td>
                <td v-if="item.status==='1'">在线</td>
                <td v-else>离线</td>
              </tr>
              </tbody>
            </table>

          </div>
          <div class="table_paging" style="margin-right:1.6%">
            <p>当前记录<span>{{(resourceCurrentPage-1)*4+1}}</span>到<span>{{(resourceCurrentPage-1)*4+resourcePageData.length}}</span>条，共<span>{{resourceTotalCount}}</span>条记录
              <button @click="resourceFirstPage()"
                      v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
              <button
                @click="resourcePrevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
              第<span>{{resourceCurrentPage}}</span>/<span>{{totalPage}}</span>页
              <button
                @click="resourceNextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
              <button @click="resourceLastPage()"
                      v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "monitoring",
    data() {
      return {
        resourceTotalCount: 0,  // 总记录条数
        resourceCurrentPage: 1, // 当前页数 ，默认为1
        resourcePageData: [],   // 当前页数据
        pageSize: 4, // 每页显示数量
        totalPage:'',
        search: [
          {
            title: '选择项目',
            options: [],
          }, {
            title: '选择群组',
            options: [],
          }, {
            title: '选择小组',
            options: [],
          },
        ],
        projectList:[],
        teamList:[],
        workList:[],
        selectProjectValue:'',
        selectTeamValue:'',
        selectWorkValue:'',
        leftbtn: [
          {name: "车流量"},
          {name: "人流量"},
          {name: "巡警出警"},
        ],
        leftbtn_number: [
          {number: "23659"},
          {number: "1233657"},
          {number: "1265"},
        ],
        rightbtn: [
          {name: "冲突"},
          {name: "可疑人"},
          {name: "禁区"},
          {name: "物品监控"},
          {name: "报警"},
          {name: "徘徊检测告警"},
        ],
        tabledata: [],

        video_id:'',
        video_id1:'',
        video_id2:'',
        video_id3:'',
        video_id4:'',
        video_0:'',
        video_2: '',//为民街南url: "rtmp://rtmp01open.ys7.com/openlive/59e642c822c440a7b04d5199adc6738b.hd"
        video_1: '',//为民街北url: "rtmp://rtmp01open.ys7.com/openlive/f5577c97891f4447ab748ab363cc0bc6.hd"
        video_4: '',//智达光电研发中心url: "rtmp://rtmp01open.ys7.com/openlive/4fac0ea09fe94e24acf40343e31fbdb8.hd"
        video_3: '',//吉祥公园url: "rtmp://rtmp01open.ys7.com/openlive/d78e47e040714154bca503d9ed4d5f46.hd"
        video_name0:'',
        video_name1:'',
        video_name2:'',
        video_name3:'',
        video_name4:'',
      }
    },
    methods: {
      InitLeftMenu:function () {
        this.$emit('getMessage', '2','0');
      },

      playerFirst2:function(){
        this.video_0 = this.video_1;
        this.video_name0 = this.video_name1;
        this.video_1 = this.video_2;
        this.video_name1 = this.video_name2;
        this.video_2 = this.video_0;
        this.video_name2 = this.video_name0;
        this.video_0 = '';
        this.video_name0 = '';
        this.video_id = this.video_id2;
        this.video_id2 = this.video_id1;
        this.video_id1 = this.video_id;
        this.playerMove1();
        this.playerMove2();
      },

      playerFirst3:function(){
        this.video_0 = this.video_1;
        this.video_name0 = this.video_name1;
        this.video_1 = this.video_3;
        this.video_name1 = this.video_name3;
        this.video_3 = this.video_0;
        this.video_name3 = this.video_name0;
        this.video_0 = '';
        this.video_name0 = '';
        this.video_id = this.video_id3;
        this.video_id3 = this.video_id1;
        this.video_id1 = this.video_id;
        this.playerMove1();
        this.playerMove3();
      },

      playerFirst4:function(){
        this.video_0 = this.video_1;
        this.video_name0 = this.video_name1;
        this.video_1 = this.video_4;
        this.video_name1 = this.video_name4;
        this.video_4 = this.video_0;
        this.video_name4 = this.video_name0;
        this.video_0 = '';
        this.video_name0 = '';
        this.video_id = this.video_id4;
        this.video_id4 = this.video_id1;
        this.video_id1 = this.video_id;
        this.playerMove1();
        this.playerMove4();
      },


      playerMove1:function(){
        var videoBoxWidth = $("#videoBox").width();
        var videoBoxHeight = $("#videoBox").height();
        var videoSource1 = '<video id="myPlayer1" class="video-js" controls playsInline webkit-playsinline autoplay=false width="'+videoBoxWidth+'px" height="'+videoBoxHeight+'px">' +
          '<source id="videoSource1" type="rtmp/flv" src="'+this.video_1+'">'+
          '</video>';
        $("#videoBox").html("");
        $("#videoBox").html(videoSource1);
        this.myPlayer1 = "";
        this.myPlayer1 = new EZuikit.EZUIPlayer('myPlayer1');
        //this.myPlayer1.play();
      },

      playerMove2:function(){
        var videoBoxWidth = $("#videoBox2").width();
        var videoBoxHeight = $("#videoBox2").height();
        var videoSource2 = '<video id="myPlayer2" class="video-js" controls playsInline webkit-playsinline autoplay=false width="'+videoBoxWidth+'px" height="'+videoBoxHeight+'px">' +
          '<source id="videoSource2" type="rtmp/flv" src="'+this.video_2+'">'+
          '</video>';
        $("#videoBox2").html("");
        $("#videoBox2").html(videoSource2);
        this.myPlayer2 = "";
        this.myPlayer2 = new EZuikit.EZUIPlayer('myPlayer2');
        //this.myPlayer2.play();
      },

      playerMove3:function(){
        var videoBoxWidth = $("#videoBox3").width();
        var videoBoxHeight = $("#videoBox3").height();
        var videoSource3 = '<video id="myPlayer3" class="video-js" controls playsInline webkit-playsinline autoplay=false width="'+videoBoxWidth+'px" height="'+videoBoxHeight+'px">' +
          '<source id="videoSource3" type="rtmp/flv" src="'+this.video_3+'">'+
          '</video>';
        $("#videoBox3").html("");
        $("#videoBox3").html(videoSource3);
        this.myPlayer3 = "";
        this.myPlayer3 = new EZuikit.EZUIPlayer('myPlayer3');;
        //this.myPlayer3.play();
      },

      playerMove4:function(){
        var videoBoxWidth = $("#videoBox4").width();
        var videoBoxHeight = $("#videoBox4").height();
        var videoSource4 = '<video id="myPlayer4" class="video-js" controls playsInline webkit-playsinline autoplay=false width="'+videoBoxWidth+'px" height="'+videoBoxHeight+'px">' +
          '<source id="videoSource4" type="rtmp/flv" src="'+this.video_4+'">'+
          '</video>';
        $("#videoBox4").html("");
        $("#videoBox4").html(videoSource4);
        this.myPlayer4 = "";
        this.myPlayer4 = new EZuikit.EZUIPlayer('myPlayer4');
       // this.myPlayer4.play();
      },


      //获取小组列表
      getSelectWork:function(id){
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "小组数据获取成功";
              this.search[2].options=[];
              this.workList = data.data;
              let options = this.search[2].options;
              for (let i=0;i<this.workList.length;i++){
                let projectObj = {};
                projectObj.label = this.workList[i].name;
                projectObj.value = this.workList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },



      //获取群组列表
      getSelectTeam:function(id){
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "群组数据获取成功";
              this.search[1].options=[];
              this.search[2].options=[];
              this.teamList = data.data;
              let options = this.search[1].options;
              for (let i=0;i<this.teamList.length;i++){
                let projectObj = {};
                projectObj.label = this.teamList[i].name;
                projectObj.value = this.teamList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },

      //回放跳转
      goHistoryVideo:function () {
        this.$router.push('/monitoring/ProtectionVideo');
      },


      //上一页
      resourcePrevPage() {
        if (this.resourceCurrentPage == 1) {
          return false;
        } else {
          this.resourceCurrentPage--;
          this.getVideoList();
        }
      },
      // 下一页
      resourceNextPage() {
        if (this.resourceCurrentPage == this.totalPage) {
          return false;
        } else {
          this.resourceCurrentPage++;
          this.getVideoList();
        }
      },
      resourceFirstPage(){
        this.resourceCurrentPage = 1;
        this.getVideoList();
      },
      resourceLastPage(){
        this.resourceCurrentPage = Math.ceil(this.resourceTotalCount/this.pageSize);
        this.getVideoList();
      },

      open:function(id,url){
        this.video_1 = url;
        this.video_id = id;
      },
      left_top: function () {
        $('.dark').addClass('colorDisable');
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:4,
          }),
          method: 'post',
        })
      },
      top: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:0,
          }),
          method: 'post',
        })
      },
      right_top: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:6,
          }),
          method: 'post',
        })
      },
      left_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:2,
          }),
          method: 'post',
        })
      },
      center_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:6,
          }),
          method: 'post',
        })
      },
      right_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:3,
          }),
          method: 'post',
        })
      },
      left_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:5,
          }),
          method: 'post',
        })
      },
      center_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:1,
          }),
          method: 'post',
        })
      },
      right_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:7,
          }),
          method: 'post',
        })
      },
      magnify:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:8,
          }),
          method: 'post',
        })
      },
      shrink:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:9,
          }),
          method: 'post',
        })
      },
      focus_add:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:11,
          }),
          method: 'post',
        })
      },
      focus_reduce:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:10,
          }),
          method: 'post',
        })
      },
      //获取列表
      getVideoList:function () {
        fetch("/api/v1/camera/DeviceList", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          method: 'post',
          body: JSON.stringify({
            project_id:this.selectProjectValue,
            groups_id:this.selectTeamValue,
            group_id:this.selectWorkValue,
            page:this.resourceCurrentPage,
          })
        })
          .then(result => {
            console.log(result);
            return result.json();//解析流
          })
          .then(data_liat => {
            this.tabledata = data_liat.data_liat;
            this.resourceTotalCount = parseInt(data_liat.data_num);
            this.resourcePageData = data_liat.data_liat;
            this.totalPage = data_liat.total_page;
            //let i = this.resourceCurrentPage;
            if(this.resourceCurrentPage==this.totalPage){
              let mark = 4 - (data_liat.total_page * 4 - data_liat.data_num);
              if(mark==1){
                this.video_id1=this.resourcePageData[0].device_serial;
                this.video_1=this.resourcePageData[0].url;
                this.video_name1=this.resourcePageData[0].site;
                this.video_id2='';
                this.video_2='';
                this.video_name2='';
                this.video_id3='';
                this.video_3='';
                this.video_name3='';
                this.video_id4='';
                this.video_4='';
                this.video_name4='';
              }else if(mark==2){
                this.video_id1=this.resourcePageData[0].device_serial;
                this.video_1=this.resourcePageData[0].url;
                this.video_name1=this.resourcePageData[0].site;
                this.video_id2=this.resourcePageData[1].device_serial;
                this.video_2=this.resourcePageData[1].url;
                this.video_name2=this.resourcePageData[1].site;
                this.video_id3='';
                this.video_3='';
                this.video_name3='';
                this.video_id4='';
                this.video_4='';
                this.video_name4='';
              }else if(mark==3){
                this.video_id1=this.resourcePageData[0].device_serial;
                this.video_1=this.resourcePageData[0].url;
                this.video_name1=this.resourcePageData[0].site;
                this.video_id2=this.resourcePageData[1].device_serial;
                this.video_2=this.resourcePageData[1].url;
                this.video_name2=this.resourcePageData[1].site;
                this.video_id3=this.resourcePageData[2].device_serial;
                this.video_3=this.resourcePageData[2].url;
                this.video_name3=this.resourcePageData[2].site;
                this.video_id4='';
                this.video_4='';
                this.video_name4='';
              }else {
                this.video_id1=this.resourcePageData[0].device_serial;
                this.video_1=this.resourcePageData[0].url;
                this.video_name1=this.resourcePageData[0].site;
                this.video_id2=this.resourcePageData[1].device_serial;
                this.video_2=this.resourcePageData[1].url;
                this.video_name2=this.resourcePageData[1].site;
                this.video_id3=this.resourcePageData[2].device_serial;
                this.video_3=this.resourcePageData[2].url;
                this.video_name3=this.resourcePageData[2].site;
                this.video_id4=this.resourcePageData[3].device_serial;
                this.video_4=this.resourcePageData[3].url;
                this.video_name4=this.resourcePageData[3].site;
                this.video_id = this.video_id1;
              }
            }else {
              this.video_id1=this.resourcePageData[0].device_serial;
              this.video_1=this.resourcePageData[0].url;
              this.video_name1=this.resourcePageData[0].site;
              this.video_id2=this.resourcePageData[1].device_serial;
              this.video_2=this.resourcePageData[1].url;
              this.video_name2=this.resourcePageData[1].site;
              this.video_id3=this.resourcePageData[2].device_serial;
              this.video_3=this.resourcePageData[2].url;
              this.video_name3=this.resourcePageData[2].site;
              this.video_id4=this.resourcePageData[3].device_serial;
              this.video_4=this.resourcePageData[3].url;
              this.video_name4=this.resourcePageData[3].site;
              this.video_id = this.video_id1;
            }
            this.playerMove1();
            this.playerMove2();
            this.playerMove3();
            this.playerMove4();
            this.selectProjectValue='';
            this.selectTeamValue='';
            this.selectWorkValue='';
          })
          .catch((error) => {
            console.log(error);
          })
      }

    },
    created(){
      this.InitLeftMenu();
      this.getVideoList();
      this.getProjectList();
    },
    mounted() {
      this.playerMove1();
      this.playerMove2();
      this.playerMove3();
      this.playerMove4();
      // var player1 = new EZuikit.EZUIPlayer('myPlayer1');
      // var player2 = new EZuikit.EZUIPlayer('myPlayer2');
      // var player3 = new EZuikit.EZUIPlayer('myPlayer3');
      // var player4 = new EZuikit.EZUIPlayer('myPlayer4');


    }
  }
</script>

<style scoped>
  .monitoring {
    width: 100%;
    height: 100%;
    position: relative;
  }

  #map {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 76px;
    padding: 20px;
    box-sizing: border-box;
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    /*background: #16518d;*/
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    min-width: 226px;
    width: calc(20% - 10px);
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    min-width: 130px;
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: #16518d;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
    background: #FFFFFF;
  }

  .search_options_box > img {
    position: absolute;
    /*top: 48px;*/
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .blue {
    background: #169bd5;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .left_btn {
    width: 200px;
    padding: 30px 0px 0px 50px;
    float: left;
  }

  .btn_icon_content {
    margin-bottom: 50px;
  }

  .btn_bg {
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    float: left;
    margin-right: 30px;
  }

  .btn_bg > span {
    color: #FFFFFF;
  }

  .btn_border {
    box-shadow: 0 0 10px #FFFFFF inset;
  }

  .btn_left_top, .btn_right_top, .btn_left_bottom, .btn_right_bottom {
    width: 10px;
    height: 10px;
    position: absolute;
    background: url("/static/img/btn_border.png") no-repeat center center;
  }

  .btn_left_top {
    top: -1px;
    left: -1px;
  }

  .btn_right_top {
    top: -1px;
    right: -1px;
    transform: rotate(90deg);
  }

  .btn_left_bottom {
    bottom: -1px;
    left: -1px;
    transform: rotate(-90deg);
  }

  .btn_right_bottom {
    bottom: -1px;
    right: -1px;
    transform: rotate(180deg);
  }

  .btn_name {
    width: auto;
    height: 52px;
  }

  .btn_name > p {
    font-size: 20px;
    color: #FFFFFF;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .btn_name > p > button {
    background: transparent;
    border: transparent;
    outline: transparent;
    color: #FFFFFF;
  }

  .btn_name > p > button:active {
    color: #00f0ff;
  }

  .btn_name > span {
    font-size: 20px;
    color: #00f0ff;
    line-height: 20px;
  }

  .right_btn {
    width: 162px;
    padding: 30px 50px 0px 0px;
    float: right;
    cursor: pointer;
  }

  .right_btn_content {
    width: 160px;
    height: 50px;
    position: relative;
    float: right;
    margin-bottom: 15px;
  }

  .right_btn_content > p {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 50px;
    margin-left: 15px;
    display: flex;
    align-items: center;
  }

  .right_btn_content > p > span {
    padding-right: 10px;
  }

  .tips {
    float: right;
    padding-right: 50px;
  }


  .tips > span {
    font-size: 40px;
    position: relative;
  }

  .angle {
    height: 14px;
    min-width: 14px;
    background: #ff0000;
    border-radius: 10px;
    font-size: 10px;
    color: #FFFFFF;
    padding: 3px;
    float: right;
    line-height: 14px;
    text-align: center;
  }

  .bottom_content {
    width: calc(100% - 40px);
    position: absolute;
  }

  .security {
    width: calc(20% - 16px);
    height: 260px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .event {
    width: calc(60% - 16px);
    height: 260px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .traffic_was {
    width: calc(20% - 16px);
    height: 260px;
    margin-bottom: 20px;
  }

  .nva_btn {
    padding: 10px 20px;
  }

  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  .real_time_monitoring {
    width: 100%;
    height: 100%;
    background: #16518d;
  }

  .video_win {
    width: 64%;
    height: calc(100% - 47px);
    float: left;
    padding: 20px 20px 20px 20px;
    box-sizing: border-box;
  }

  .operation_win {
    width: 36%;
    height: calc(100% - 47px);
    float: right;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
  }

  .video_box {
    width: 100%;
    height: 76%;
    background: #0e345b;
    margin-bottom: 10px;
  }

  .m_video_box {
    width: 32.5%;
    height: 100%;
    background: #0e345b;
    float: left;
  }

  .n_video_box {
    width: 32.5%;
    height: 100%;
    float: left;
  }

  .control_btn {
    width: 100%;
    height: 150px;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
  }

  .direction_btn {
    width: 50%;
    height: 100%;
  }

  .direction_btn > button {
    width: 30%;
    height: 30%;
    margin-bottom: 10px;
    background: transparent;
    border: 1px solid #5c86af;
    outline: transparent;
    border-radius: 6px;
    color: #00f0ff;
  }

  .monitory_point {
    width: 100%;
    height: 100px;
    float: left;
    margin-bottom: 20px;
  }

  .monitory_point_box {
    width: 50%;
    float: left;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    padding-right: 20px;
    box-sizing: border-box;
    position: relative;
  }

  .monitory_point_box > span {
    width: 64px;
    margin-right: 8px;
    color: #FFFFFF;
  }

  .monitory_point_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #FFFFFF;
    appearance: none;
    padding-left: 10px;
    outline: transparent;
    color: #FFFFFF;
    cursor: pointer;
  }

  .monitory_point_box option {
    color: #000000;

  }

  .monitory_point_box > img {
    position: absolute;
    right: 40px;
    cursor: pointer;
  }

  .table_content {
    width: 100%;
    padding: 20px 0;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input {
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 52px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #094b8e;
    border-radius: 6px;
    position: absolute;
    top: 690px;
    left: -10px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #FFFFFF;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .video_win_btn {
    margin-top: 10px;
  }

  .video_box > video, .m_video_box > video {
    width: 100%;
    height: 100%;
  }

  .dark button.colorDisable{background:#AEB0AF;}
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/3_protection/monitoring.vue